import FieldProto from "../../fields3/proto/field-proto";
import {GroupByOptions, GroupedData} from "../group";
import {SortDirection} from "../sort";
import ModelEntity from "../../model2/model-entity";

const debug = false
// const debug = "groupByOperator"

export default function groupByOperatorDeprecated(models:ModelEntity[], field:FieldProto, sortDirection:SortDirection) {
    debug && console.log(debug, 'process() total models=', _.size(models), field, sortDirection)

    const fieldId = field.fieldId

    const result:GroupedData = _(models)
        .groupBy((model)=>{
            // this is done to prevent difference between null and undefined !

            // @ts-ignore
            let value = model[fieldId]
            if (!value){
                // field.getValue allows fields to provide a model-level fallback
                // (e.g. FieldProjectStatus uses systemStatus when statusId is null)
                value = field.getValue(model)
            }


            const groupByValue = field.groupValue(value)

            return !_.isNil(groupByValue) ? groupByValue : null;

        })
        .toPairs()
        .map((group)=> {
            return {
                value       : group[0],
                sortValue   : field.groupSortValue(group[0]),
                field       : field,
                label       : field.groupLabel(group[0]),
                items       : group[1]
            }
        })
        .orderBy(group=>group.sortValue, sortDirection as any)
        .value() as GroupedData;

    debug && console.log(debug, 'process result', result)

    return result
}

// export default function groupByOperator(models:Task[], field:FieldProto, sortDirection:SortDirection) {
//     debug && console.log(debug, 'process() total models=', _.size(models), field, sortDirection)
//
//     const fieldId = field.fieldId
//
//     const result:GroupedData = _(models)
//         .groupBy((model)=>{
//             // this is done to prevent difference between null and undefined !
//
//             // @ts-ignore
//             const value = model[fieldId]
//
//             const groupByValue = field.groupValue(value)
//
//             return !_.isNil(groupByValue) ? groupByValue : null;
//
//         })
//         .toPairs()
//         .map((group)=> {
//             return {
//                 value       : group[0],
//                 sortValue   : field.groupSortValue(group[0]),
//                 field       : field,
//                 label       : field.groupLabel(group[0]),
//                 items       : group[1]
//             }
//         })
//         .orderBy(group=>group.sortValue, sortDirection as any)
//         .value() as GroupedData;
//
//     debug && console.log(debug, 'process result', result)
//
//     return result
// }
